import React from 'react';

import * as S from './TripsHotelDetails.styles';

import useCarousel from '../../../../../../../../hotels-dweb/src/shared/hooks/useCarousel';
import Modal, {useModal} from '../../../../../../../../hotels-dweb/src/shared/components/Modal';
import ViewMoreDetails from '../../../../../../../../hotels-dweb/src/stories/components/hotels/DetailsPage/ViewRoomDetails/ViewRoomDetails';

const TripHotelDetails = ({hotelDetails}) => {
  if (!hotelDetails.showHotelDetails) {
    return null;
  }

  const {hotelName, amenities, images, upforntAmenities, upforntImages, additionalImagesCount, additionalAmenitiesCount} = hotelDetails;

  const {isModalOpen, closeModal, openModal} = useModal();

  const {
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(images, 1);

  return(
    <S.TripHotelDetailMainWrap>
      <S.TripHotelDetailHeaderWrap>
        <S.TripHotelHeaderText>HOTEL DETAILS</S.TripHotelHeaderText>
        <S.TripHotelHeaderSubText>More about {hotelName}</S.TripHotelHeaderSubText>
      </S.TripHotelDetailHeaderWrap>
      <S.TripHotelAmenitiesWrap>
        <S.TripHotelAmenitiesInnerWrap>
          <S.HotelAmenitiesWrap>
            <S.HotelAmenitiesList>
              {upforntAmenities.map((amenity, i) => <li key={`amenity${i}`}>{amenity}</li>)}
            </S.HotelAmenitiesList>
          </S.HotelAmenitiesWrap>
          {(additionalAmenitiesCount > 0 && <S.HotelShowAllAmenitiesWrap onClick={() => openModal()}>
            <S.ShowAllAmenitesText>+{additionalAmenitiesCount} Amenities</S.ShowAllAmenitesText>
          </S.HotelShowAllAmenitiesWrap>) || null}
        </S.TripHotelAmenitiesInnerWrap>
        <S.TripHotelImagesWrap>
          {upforntImages.map((img, i) => <S.HotelImageTrip src={img} alt={`img${i}`} key={`img${i}`} />)}          
          {(additionalImagesCount > 0 && <S.MoreHotelImageTrip onClick={() => openModal()}>
            <S.MoreImgText>+{additionalImagesCount} <br /><span>Photos</span></S.MoreImgText>
          </S.MoreHotelImageTrip>) || null}
        </S.TripHotelImagesWrap>
      </S.TripHotelAmenitiesWrap>

      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalStyles={{
          height: '90vh',
          width: 'auto',
        }}
        CloseButton={() => null}
      >
        <ViewMoreDetails
          roomDescription=""
          roomFacilities={amenities}
          roomTypeName="Hotel Details"
          roomImages={images}
          closeModal={closeModal}
          onRightArrowClick={increment}
          onLeftArrowClick={decrement}
          showLeftArrow={isLeftCursorActive}
          showRightArrow={isRightCursorActive}
          leftCursor={leftCursor}
          rightCursor={rightCursor}
        />
      </Modal>
    </S.TripHotelDetailMainWrap>
  );
}

export default TripHotelDetails;